var Alphabet = /* @__PURE__ */ ((Alphabet2) => {
  Alphabet2["PY"] = "py";
  Alphabet2["CMU"] = "cmu";
  return Alphabet2;
})(Alphabet || {});
((Alphabet2) => {
  function fromString(alphabet) {
    switch (alphabet) {
      case "py":
        return "py" /* PY */;
      case "cmu":
        return "cmu" /* CMU */;
      default:
        return void 0;
    }
  }
  Alphabet2.fromString = fromString;
})(Alphabet || (Alphabet = {}));

export { Alphabet };
//# sourceMappingURL=alphabet.enum.js.map
